import * as React from 'react'
import './index.scss'
import {connect} from "react-redux";
import {ActionType, reducerStoreType} from "../../reducers/types";
import {Dispatch} from "redux";
import FormControl from "@material-ui/core/FormControl";
import {Label, MyInput, PrimaryButton, WhiteButton} from "../CustomUIComp/CustomFormElem";
import {CODES, SALT_STRING} from "../../constants";
import md5 from "js-md5";
import API from "../../api/api";
import FormHelperText from "@material-ui/core/FormHelperText";
import {toast} from "react-toastify";
import {injectIntl, IntlShape} from 'react-intl'

interface IProps {
    dispatch: Dispatch<ActionType<any>>,
    handleClose: () => void,
    email: string,
    intl: IntlShape
}
interface IState {
    oldPwd: string,
    password: string,
    confirmPassword: string,
    errors: { [key: string]: string }
}

class ChangePasswordModal extends React.Component<IProps, IState> {

    constructor(props: IProps){
        super(props)
        this.state = {
            oldPwd: '',
            password: '',
            confirmPassword: '',
            errors: {}
        }
    }

    handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        let newState = {
            ...this.state,
            [event.target.name]: event.target.value
        }
        console.log(newState)
        this.setState(newState)
    }
    check = () => {
        let {intl}  = this.props
        let errors :{[key: string]: string} = {}
        if(!this.state.oldPwd){
            errors['oldPwd'] = intl.formatMessage({id: 'oldPasswrodNotNull'})
        }
        if(!this.state.password){
            errors['password'] = intl.formatMessage({id: 'newPasswrodNotNull'})
        }else if(this.state.password.length < 6){
            errors['password'] = intl.formatMessage({id: 'passLengthError'})
        }

        if(!this.state.confirmPassword){
            errors['confirmPassword'] = intl.formatMessage({id: 'confirmPasswrodNotNull'})
        }else if(this.state.confirmPassword !== this.state.password){
            errors['confirmPassword'] = intl.formatMessage({id: 'passConfirmError'})
        }
        this.setState({errors: errors})
        if(Object.keys(errors).length === 0){
            return true
        }else {
            return false
        }
    }
    onConfirm = () => {
        let {intl} = this.props
        if(this.check()){
            let params = {
                clientId:'h5',
                email: this.props.email,
                password: md5(this.state.password + SALT_STRING),
                oldPwd: md5(this.state.oldPwd + SALT_STRING)
            }
            API.modifyPassword(params).then((resp) => {
                console.log(resp)
                if(resp.code === CODES.SUCCESS) {
                    toast.success(intl.formatMessage({id: 'modifyPassSucc'}))
                    this.props.dispatch({type: 'LOGOUT', payload: undefined})
                }
            })
        }
    }

    public render() {
        let errors = this.state.errors
        let {intl} = this.props

        return <div className="changePasswordModal">
            <div className="LoginForm">
                <FormControl className="formControl" fullWidth required error={errors['oldPwd'] ? true : false}>
                    <Label shrink htmlFor="oldPassword">
                        {intl.formatMessage({id: 'oldPass'})}
                    </Label>
                    <MyInput type="password"
                            value={this.state.oldPwd}
                            onChange={this.handleInputChange}
                            name="oldPwd"/>
                    {errors['oldPwd'] ?
                    <FormHelperText id="oldPwd-error-text">{errors['oldPwd']}</FormHelperText> : null}
                </FormControl>

                <FormControl className="formControl" fullWidth required error={errors['password'] ? true : false}>
                    <Label shrink htmlFor="newPassword">
                        {intl.formatMessage({id: 'newPass'})}
                    </Label>
                    <MyInput type="password"
                            value={this.state.password}
                            onChange={this.handleInputChange}
                            name="password"/>
                    {errors['password'] ?
                    <FormHelperText id="password-error-text">{errors['password']}</FormHelperText> : null}
                </FormControl>
                <FormControl className="formControl" fullWidth required error={errors['confirmPassword'] ? true : false}>
                    <Label shrink htmlFor="confirmPassword">
                        {intl.formatMessage({id: 'confirmPass'})}
                    </Label>
                    <MyInput type="password"
                            value={this.state.confirmPassword}
                            onChange={this.handleInputChange}
                            name="confirmPassword"/>
                    {errors['confirmPassword'] ?
                    <FormHelperText id="confirm-password-error-text">{errors['confirmPassword']}</FormHelperText> : null}
                </FormControl>
            </div>
            <div className="button-line">
                <WhiteButton onClick={this.props.handleClose}>
                    {intl.formatMessage({id: 'cancel'})}
                </WhiteButton>
                <PrimaryButton onClick={this.onConfirm}>
                    {intl.formatMessage({id: 'confirm'})}
                </PrimaryButton>
            </div>
        </div>;
    }
}

export default injectIntl(connect((state: reducerStoreType) => {
    return {
        email: state.app.userInfo ? state.app.userInfo.email : ''
    }
})(ChangePasswordModal))
